export default class Form {
  surname ='';
  email ='';
  gender ='';
  country ='';
  confirmPrivacy=false;
  confirmAge=false;
}